import React from 'react';
import CoreException from './index';

const NotFound = function () {
  return <CoreException type="404" />;
};

export default NotFound;
